import { useState } from "react";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import Table from "./Table";
import { usePostItemListMutation } from "../../../../store/api/purchaseorderapi";
import { useGetSelectedCompanyQuery } from '../../../../store/api/companyapi'
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import { useGetWorkOrderBomListQuery, useGetWorkOrderItemListQuery, usePostCreateAssemblyMutation } from "../../../../store/api/assemblyapi";
import { useNavigate } from "react-router-dom";

const AssemblyForm = () => {
  const nvg = useNavigate()
  const [tab, settab] = useState(1)
  const [podate, setpodate] = useState(new Date().toISOString().split('T')[0])
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error")
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);
  const [po_response, setpo_response] = useState("");
  const [selectWOItem, setselectWOItem] = useState(""); // item
  const [selectWOBOM, setselectWOBOM] = useState(""); //bom no
  const [QtyToManufacture, setQtyToManufacture] = useState(''); //qty
  const [selected_item_data, setselected_item_data] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({
   WOItem: false,
    WOBOM: false,
    QTY: false,
    items: false
  });
  const [getitem_list_data] = usePostItemListMutation();
  const { data } = useGetSelectedCompanyQuery();
  const selectcompany = data?.message?.data?.company; // company
  console.log("cjeck select co,pany",data)
  const { data: WO_bom } = useGetWorkOrderBomListQuery();
  const [createApi] = usePostCreateAssemblyMutation() 

  const validateForm = () => {
    const errors = {
      WOItem: !selectWOItem,
      WOBOM: !selectWOBOM,
      QTY: !QtyToManufacture || isNaN(QtyToManufacture) || Number(QtyToManufacture) <= 0,
      // items: selected_item_data.length === 0
    };
    
    setFieldErrors(errors);
    return !Object.values(errors).some(error => error);
  };

  const CreatePurchaseOrder = async () => {
    if (!validateForm()) {
      setError('Please fill all required fields correctly');
      setptype('Error');
      setShowError(true);
      return;
    }

    try {
      const payload = {
        bom_no: selectWOBOM,
        item: selectWOItem,
        qty: Number(QtyToManufacture),
        company: selectcompany,
        save: true
      };

      const response = await createApi(payload).unwrap();
      
      setpo_response(response);
      setTimeout(() => {
        nvg('/assmbly/draft/create-assembly',{ state:response.message.work_order})
      }, 3000);

      setptype('Success');
      setError('Work Order created successfully!');
      setShowError(true);
      setfinalstep(true);
    } catch (err) {
      setptype('Error');
      setError(err.data?.message || 'Failed to create Work Order');
      setShowError(true);
    }
  }


  const SubmitPurchaseOrder = async () => {
  }

  return (
    <FormLayout
      title="New Work Order"
      breadcrumbs={[
        { label: "Work Order" },
        { label: "Work Order List", url: "/assmbly/assembly-list" }
      ]}
      status={'New'}
      finalStep={false}
      actionButtons={
        <>
         <Button
            className="custom-btn-00989"
            onClick={po_response.result ? SubmitPurchaseOrder : CreatePurchaseOrder}
            iconName="LuFilePlus2"
            style={{ gap: '2px', height: '28px' }}
            iconSize={12}
            display={finalstep ? 'none' : 'flex'}
          >
            {po_response.result ? 'Submit' : 'Save'}
          </Button>

         
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
          <div className="d-flex justify-content-between align-items-end ">

            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                  Production Item{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                </a>
              </li>
            </ul>

            <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
              <span style={{ position: 'relative', top: '-1px' }}>
                <GetIcon iconName="CgAttachment" size={12} />
              </span>
              <span className=" fw-semibold" style={{ color: "#391F84" }}>
                Attachments
              </span>
            </div>

          </div>
        </div>

        <div className="row d-flex justify-content-between" style={{ marginTop: '14px',flexGrow:'1' }}>
          <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
            <Tab1 
            WOI={{setselectWOItem, selectWOItem, Error: fieldErrors.WOItem }}
             WOBOM={{setselectWOBOM, selectWOBOM, Error: fieldErrors.WOBOM }}
             qty={{setQtyToManufacture, QtyToManufacture, Error: fieldErrors.QTY }}
             podate={{ podate, setpodate }} ponumber={po_response?.result}
              />
          </div>
          <div className="col-9 d-flex flex-column mt-2" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', minHeight: tab == 1 ? '440px' : '0' }}>
            <div className="d-flex pb-2" style={{ gap: '5px' }}>
              <p className="NoOfLine">No. of lines - <span style={{ color: '#2563EB' }}> {selected_item_data.length}</span></p>
              <p className="TotalQty">Total Quantity -  <span style={{ color: '#16A34A' }}> {selected_item_data.reduce((total, item) => { return total + Number(item.quantity); }, 0)}</span></p>
            </div>
            <div className="tableLabel">
              <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
              <p className="" style={{ color: "#1E1E1E", fontWeight: '500', marginBottom: '4px',fontSize:'15px' }}>
                Required Items
              </p>
            </div>
            <Table setselected_item_data={setselected_item_data} list_data={getitem_list_data} po_status={po_response} />
           
          </div>
          
        </div>
      </div>
      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayout>
  );
};

export default AssemblyForm;